import { Link } from 'react-router-dom';

export default function SoyBodyMakePage() {
  return (
    <div className="min-h-screen bg-white text-[#5D4037]">
      {/* Header */}
      <header className="bg-white border-b border-[#E0D7D0] sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <span className="font-bold text-xl text-[#bc6355]">プロテイン選びの教科書</span>
        </div>
      </header>

      {/* Breadcrumb */}
      <nav className="bg-[#FAF9F8] border-b border-[#E0D7D0]">
        <div className="container mx-auto px-6 py-3">
          <ul className="flex items-center gap-2 text-sm">
            <li>
              <a
                href="https://soyproteinranking.com/"
                className="flex items-center gap-2 text-[#8D6E63] hover:text-[#bc6355] transition-colors whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center text-[#bc6355]">
                  <i className="ri-home-4-line"></i>
                </span>
                <span>トップ</span>
              </a>
            </li>
            <li className="text-[#BCAAA4]">/</li>
            <li className="text-[#5D4037] whitespace-nowrap">
              女性らしい体を作るボディメイク術
            </li>
          </ul>
        </div>
      </nav>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-12 max-w-4xl">
        {/* Hero Section */}
        <section className="mb-12">
          <h1 className="text-3xl font-bold text-white mb-6 bg-gradient-to-r from-[#bc6355] to-[#d4847a] px-6 py-4 rounded-lg leading-tight">
            女性らしい体を作る！ソイプロテインがボディメイクに最適な理由
          </h1>

          <p className="text-[#5D4037] leading-relaxed mb-4">
            「ただ痩せるだけじゃなく、女性らしいしなやかなメリハリが欲しい」と思ったことはありませんか？
          </p>

          <p className="text-[#5D4037] leading-relaxed">
            筋肉をムキムキにするのではなく、程よく引き締まった美しいラインを目指す女性にとって、
            <span className="text-[#bc6355] font-semibold underline decoration-[#F9EBEA] decoration-4">
              「ソイプロテイン」はまさに理想的なパートナー。
            </span>
            なぜソイがボディメイクにおいて選ばれるのか、その秘密を解き明かします。
          </p>
        </section>

        {/* Feature Section (3 Reasons for Body Make) */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#5D4037] mb-6 pb-3 border-b-4 border-[#bc6355]">
            ボディメイクを加速させる3つのメリット
          </h2>

          <p className="text-[#5D4037] leading-relaxed mb-6">
            ソイプロテインは、ただの栄養補給にとどまらない「ボディメイク特化」のポテンシャルを秘めています。
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="p-4 bg-[#FDF8F3] rounded-lg border border-[#E8DDD4]">
              <h4 className="font-bold text-[#bc6355] mb-2">しなやかな筋量キープ</h4>
              <p className="text-sm">
                植物性アミノ酸が、太すぎない「しなやかな筋肉」をサポート。曲線美を守ります。
              </p>
            </div>
            <div className="p-4 bg-[#FDF8F3] rounded-lg border border-[#E8DDD4]">
              <h4 className="font-bold text-[#bc6355] mb-2">女性らしいライン</h4>
              <p className="text-sm">
                イソフラボンの働きが、内側から女性らしいハリのあるボディラインを支えます。
              </p>
            </div>
            <div className="p-4 bg-[#FDF8F3] rounded-lg border border-[#E8DDD4]">
              <h4 className="font-bold text-[#bc6355] mb-2">余分な脂肪をブロック</h4>
              <p className="text-sm">
                大豆サポニンが脂肪の蓄積を抑え、すっきりとしたシルエット作りを助けます。
              </p>
            </div>
          </div>
        </section>

        {/* Comparison Table (Diet vs Body Make) */}
        <section className="mb-12">
          <h3 className="text-xl font-bold text-[#5D4037] mb-6">
            「ただの減量」と「ソイボディメイク」の違い
          </h3>

          <div className="overflow-hidden rounded-lg border border-[#E0D7D0] shadow-sm mb-8 bg-white">
            <table className="w-full text-center">
              <thead>
                <tr className="bg-[#FAF9F8]">
                  <th className="px-6 py-4 text-sm font-semibold text-[#5D4037] border-b border-[#E0D7D0]">
                    チェック項目
                  </th>
                  <th className="px-6 py-4 text-sm font-semibold text-[#5D4037] border-b border-[#E0D7D0]">
                    過度な食事制限
                  </th>
                  <th className="px-6 py-4 text-sm font-semibold text-[#bc6355] border-b border-[#E0D7D0]">
                    ソイボディメイク
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#E0D7D0]">
                <tr>
                  <td className="px-6 py-4 bg-[#FAF9F8] font-semibold text-sm">見た目</td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">ゲッソリ、元気が無い</td>
                  <td className="px-6 py-4 text-[#bc6355] font-semibold text-sm">引き締まって若々しい</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 bg-[#FAF9F8] font-semibold text-sm">お肌のハリ</td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">カサつきやすい</td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">潤い・艶をキープ</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 bg-[#FAF9F8] font-semibold text-sm">リバウンド</td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">筋肉が減りしやすい</td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">代謝を維持しにくい</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Tips Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#5D4037] mb-6 pb-3 border-b-4 border-[#bc6355]">
            理想のスタイルに近づくための秘訣
          </h2>

          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#5D4037] mb-4 border-l-4 border-[#bc6355] pl-3">
              「運動後の1杯」が、未来の形を変える
            </h4>
            <p className="text-[#5D4037] leading-relaxed">
              ヨガやピラティス、軽いウォーキングなどの後にソイプロテインを取り入れることで、使った筋肉を優しく補修。ガッチリした筋肉ではなく、<strong>「触れたくなるような柔らかそうな質感」</strong>を残したまま体を引き締めることができます。
            </p>
          </div>

          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#5D4037] mb-4 border-l-4 border-[#BCAAA4] pl-3">
              夜の置き換えで「翌朝のコンディション」を整える
            </h4>
            <p className="text-[#5D4037] leading-relaxed">
              ついつい食べ過ぎてしまう夕食をソイプロテインに置き換える（または量を半分にして追加する）と、翌朝のむくみがスッキリしやすくなります。大豆の食物繊維成分がスッキリした毎日を後押しし、<strong>「お腹周りのライン」</strong>に自信が持てるようになります。
            </p>
          </div>
        </section>

        {/* Goal Checklist */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#5D4037] mb-6 pb-3 border-b-4 border-[#bc6355]">
            こんな理想をお持ちの方へ
          </h2>

          <div className="bg-gradient-to-br from-[#FAF9F8] to-[#F3EFEF] rounded-xl p-8 border border-[#E0D7D0] shadow-sm">
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  <i className="ri-heart-fill"></i>
                </div>
                <p className="text-[#5D4037]">
                  ウエストは細く、でもバストやヒップの丸みは残したい
                </p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  <i className="ri-heart-fill"></i>
                </div>
                <p className="text-[#5D4037]">
                  肌荒れを防ぎながら、健康的にウェイトコントロールしたい
                </p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  <i className="ri-heart-fill"></i>
                </div>
                <p className="text-[#5D4037]">
                  きついトレーニングよりも、毎日の習慣で美しくなりたい
                </p>
              </li>
            </ul>
          </div>
        </section>

        {/* Summary Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#5D4037] mb-6 pb-3 border-b-4 border-[#bc6355]">
            まとめ
          </h2>

          <div className="bg-[#bc6355] text-white rounded-xl p-8 shadow-sm">
            <div className="space-y-4 leading-relaxed">
              <p>
                ソイプロテインは、私たちが本来持っている<strong>「女性らしさ」を引き出しながら、不要なものを削ぎ落としてくれる</strong>魔法のようなサプリメントです。
              </p>
              <p>
                焦らず、毎日の一杯を楽しみながら。ソイの力を味方につけて、鏡を見るのが楽しくなるような理想のボディラインをデザインしていきましょう。
              </p>
              <p className="pt-4 text-center font-bold border-t border-[#d4847a]">
                しなやかに、自分らしく。ソイプロテインで最高の自分へ。
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}